import axios from "axios";

const backend = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const API = `${backend}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("js_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const authAttempt = /\/auth\/(login|register|google|apple|reset|forgot)/.test(url);
    if (status === 401 && !authAttempt) {
      localStorage.removeItem("js_token");
      window.dispatchEvent(new Event("js-unauthorized"));
    }
    if (status === 402) {
      window.dispatchEvent(new Event("js-paywall"));
    }
    return Promise.reject(error);
  }
);

export const PDF_URL = (id) => `${API}/invoices/${id}/pdf`;
export const SHARE_PDF_URL = (shareId) => `${API}/share/${shareId}/pdf`;
export const FILE_URL = (path) => (path?.startsWith("http") ? path : `${backend}${path}`);

export const PRIVACY_URL = process.env.REACT_APP_PRIVACY_URL || "/privacy.html";
export const TERMS_URL = process.env.REACT_APP_TERMS_URL || "/terms.html";

export async function downloadAuthed(path, filename) {
  const response = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename || "download";
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const money = (n) =>
  `$${(Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
